"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTransportPlanActivityTableData = void 0;
const lodash_es_1 = require("lodash-es");
const useDateFormatter_1 = require("../../../util/useDateFormatter");
const useTransportPlanActivityTableData = (feed) => {
    const { formatDateTime, formatDayDate } = (0, useDateFormatter_1.useDateFormatter)();
    const updatedDate = feed.activity?.customField?.['date'];
    const utcOffset = feed.activity?.customField?.['utcOffsetHours'];
    const reason = feed.activity?.customField?.['reason'];
    const isAggregate = feed.activity?.aggregation?.role === 'aggregate';
    const updatedFormattedDate = (0, useDateFormatter_1.isDateTime)(updatedDate)
        ? formatDateTime(updatedDate, utcOffset)
        : formatDayDate(updatedDate, utcOffset);
    const getTableData = () => {
        if (feed.activity.object?.trackables) {
            const columnNames = [
                'activity-feed_transport-plan-update_date',
                'activity-feed_transport-plan-update_container-number',
            ];
            const rows = isAggregate
                ? [
                    [
                        updatedFormattedDate,
                        feed.activity.object?.trackables
                            .map((item) => item.containerNumber)
                            .filter((item) => item)
                            .join(' | ') || '-',
                    ],
                ]
                : feed.activity.object?.trackables?.map(({ containerNumber }) => {
                    return [updatedFormattedDate, containerNumber ?? '-'];
                });
            return { columnNames, rows };
        }
        return {
            columnNames: [
                'activity-feed_transport-plan-update_date',
                ...(reason ? ['activity-feed_transport-plan-update_reason'] : []),
            ],
            rows: [(0, lodash_es_1.compact)([updatedFormattedDate, reason])],
        };
    };
    return getTableData();
};
exports.useTransportPlanActivityTableData = useTransportPlanActivityTableData;
//# sourceMappingURL=useTransportPlanActivityTableData.js.map